const modes = [
  {
    icon: "ri-layout-grid-fill",
    title: "阅读模式自由切换",
    desc: "支持滚动阅读、翻页阅读、双页横屏等多种模式,一键切换,随心选择最适合你的追漫方式。",
  },
  {
    icon: "ri-smartphone-line",
    title: "横屏观看高清原图",
    desc: "旋转屏幕即可横屏阅读,放大呈现每一格画面的细节,原图级画质更震撼。",
  },
  {
    icon: "ri-moon-clear-fill",
    title: "夜间模式护眼阅读",
    desc: "深色背景搭配低蓝光设计,夜间追漫不刺眼,长时间阅读也不容易疲惫。",
  },
  {
    icon: "ri-hand-heart-fill",
    title: "舒适翻页体验",
    desc: "流畅细腻的翻页动效与页面切换,指尖滑动顺滑自然,享受舒适的阅读节奏。",
  },
];

export default function FeatureModes() {
  return (
    <section className="container-site py-16 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <p className="inline-flex items-center gap-2 text-xs font-medium text-primary-600">
          <i className="ri-sparkling-2-fill"></i>
          沉浸式体验
        </p>
        <h2 className="mt-2 text-2xl font-semibold text-foreground-950 md:text-3xl">
          为追漫而生,为舒适而设计
        </h2>
        <p className="mt-4 text-sm leading-relaxed text-foreground-700">
          漫画岛从阅读场景出发,用心打磨每一个细节,让高清原图与舒适体验相伴你的每一次追漫。
        </p>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {modes.map((mode) => (
          <article
            key={mode.title}
            className="rounded-lg bg-background-100 p-6 transition-colors hover:bg-primary-50"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className={`${mode.icon} text-xl`}></i>
            </span>
            <h3 className="mt-5 text-base font-semibold text-foreground-950">{mode.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-700">{mode.desc}</p>
          </article>
        ))}
      </div>
    </section>
  );
}